const QUERY = gql`
  query PurchaseOrderEmailQuery($slug: String!) {
    purchaseOrder(slug: $slug) {
      id
      slug
      businessEntity {
        id
        name
      }
      businessEntityContact {
        id
        name
        email
      }
      vendorPo
      submittedAt
      shipment {
        id
        shipDate
      }
      receiveDate
      metrics {
        id
        totalCost
      }
      shipment {
        id
        freightCompany {
          id
          name
        }
        terms
      }
      salesTerms
      subsidiary {
        id
        description
      }
      customFields
    }
  }
`;

export default { QUERY };
